import comp from "./AITutorChat";
export default comp;
